import { get, post } from "../GenericServices";

const ProjectInvoice = {
  getDataProjectInvoice: (id, querystring) => {
    return get(`project/${id}/invoice?${querystring}`);
  },
  changeProject: (data) => {
    return post(`project/account-transfer`, data);
  },
};

export default ProjectInvoice;
